<template>
  <div>
        <el-card class="">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('reportCustomGroupManage.queryCondition') }}</span>
          </div>
          <el-form :inline="true" :model="reportCustomGroupManageInfo.conditions" class="flex justify-start">
            <el-form-item>
                <el-form-item>
                  <el-input v-model="reportCustomGroupManageInfo.conditions.groupId" 
                            :placeholder="$t('reportCustomGroupManage.inputGroupId')" 
                            clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="reportCustomGroupManageInfo.conditions.name" 
                            :placeholder="$t('reportCustomGroupManage.inputGroupName')" 
                            clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="reportCustomGroupManageInfo.conditions.url" 
                            :placeholder="$t('reportCustomGroupManage.inputGroupUrl')" 
                            clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="_queryReportCustomGroupMethod" icon="el-icon-search">
                    {{ $t('reportCustomGroupManage.query') }}
                  </el-button>
                  <el-button type="primary" @click="_resetReportCustomGroupMethod" icon="el-icon-refresh">
                    {{ $t('reportCustomGroupManage.reset') }}
                  </el-button>
                </el-form-item>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card class="margin-top-sm">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('reportCustomGroupManage.reportGroupInfo') }}</span>
            <el-button type="primary" @click="_openAddReportCustomGroupModal" icon="el-icon-plus" style="float: right;">
              {{ $t('reportCustomGroupManage.add') }}
            </el-button>
          </div>
          <el-table :data="reportCustomGroupManageInfo.reportCustomGroups" border style="width: 100%">
            <el-table-column prop="groupId" :label="$t('reportCustomGroupManage.groupId')" align="center"></el-table-column>
            <el-table-column prop="name" :label="$t('reportCustomGroupManage.groupName')" align="center"></el-table-column>
            <el-table-column prop="url" :label="$t('reportCustomGroupManage.groupUrl')" align="center"></el-table-column>
            <el-table-column prop="remark" :label="$t('reportCustomGroupManage.description')" align="center"></el-table-column>
            <el-table-column :label="$t('reportCustomGroupManage.operation')" align="center" width="200">
              <template slot-scope="scope">
                <el-button size="mini" @click="_openEditReportCustomGroupModel(scope.row)">
                  {{ $t('reportCustomGroupManage.edit') }}
                </el-button>
                <el-button size="mini" type="danger" @click="_openDeleteReportCustomGroupModel(scope.row)">
                  {{ $t('reportCustomGroupManage.delete') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="reportCustomGroupManageInfo.total"
            style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-card>

    <add-report-custom-group ref="addReportCustomGroup"></add-report-custom-group>
    <edit-report-custom-group ref="editReportCustomGroup"></edit-report-custom-group>
    <delete-report-custom-group ref="deleteReportCustomGroup"></delete-report-custom-group>
  </div>
</template>

<script>
import { listReportCustomGroup } from '@/api/dev/reportCustomGroupApi'
import AddReportCustomGroup from '@/components/dev/addReportCustomGroup/addReportCustomGroup'
import EditReportCustomGroup from '@/components/dev/editReportCustomGroup/editReportCustomGroup'
import DeleteReportCustomGroup from '@/components/dev/deleteReportCustomGroup/deleteReportCustomGroup'

export default {
  name: 'ReportCustomGroupManage',
  components: {
    AddReportCustomGroup,
    EditReportCustomGroup,
    DeleteReportCustomGroup
  },
  data() {
    return {
      reportCustomGroupManageInfo: {
        reportCustomGroups: [],
        total: 0,
        conditions: {
          groupId: '',
          name: '',
          url: '',
          page: 1,
          row: 10
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._listReportCustomGroups(this.currentPage, this.pageSize)
  },
  methods: {
    async _listReportCustomGroups(page, rows) {
      this.reportCustomGroupManageInfo.conditions.page = page
      this.reportCustomGroupManageInfo.conditions.row = rows
      try {
        const res = await listReportCustomGroup(this.reportCustomGroupManageInfo.conditions)
        this.reportCustomGroupManageInfo.reportCustomGroups = res.data
        this.reportCustomGroupManageInfo.total = res.total
      } catch (error) {
        console.error('获取报表组列表失败:', error)
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listReportCustomGroups(this.currentPage, this.pageSize)
    },
    _openAddReportCustomGroupModal() {
      this.$refs.addReportCustomGroup.open()
    },
    _openEditReportCustomGroupModel(row) {
      this.$refs.editReportCustomGroup.open(row)
    },
    _openDeleteReportCustomGroupModel(row) {
      this.$refs.deleteReportCustomGroup.open(row)
    },
    _queryReportCustomGroupMethod() {
      this.currentPage = 1
      this._listReportCustomGroups(this.currentPage, this.pageSize)
    },
    _resetReportCustomGroupMethod() {
      this.reportCustomGroupManageInfo.conditions = {
        groupId: '',
        name: '',
        url: '',
        page: 1,
        row: 10
      }
      this._listReportCustomGroups(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style scoped>
</style>